// extracted by mini-css-extract-plugin
export var infoRow = "_pg-2";
export var labelContainer = "_pg-0";
export var rightInfo = "_pg-1";